import React from "react";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import $ from "jquery";

const UpdateProductModal = ({
  updateHandleChange,
  selectedRowsData,
  getData,
}) => {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");

  const companyName = selectedRowsData.companyDetails?.company_name || "";
  const companyLocation = selectedRowsData.companyDetails?.location || "";
  const companyType = selectedRowsData.companyDetails?.type || "";
  const companyId = selectedRowsData.companyDetails?.id || "";

  const closeModal = () => {
    $(".custon-close-button-color").trigger("click");
  };

  const updateProduct = async (e) => {
    e.preventDefault();
    const { id, product_name, size, company_id, date } = selectedRowsData;
    let BASE_URL = SERVER_URL + `/api/product/products/${user_id}`;

    const res = await fetch(BASE_URL, {
      method: "PUT",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id,
        company_id: companyId,
        product_name,
        size,
      }),
    });
    const response = await res.json();
    if (res.ok) {
      closeModal();
      setTimeout(() => {
        toast.success(response.message);
        // navigate("/dashboard");
      }, 1000);
      getData();
    } else {
      toast.error(response.message);
      getData();
    }
  };
  return (
    <>
      <div
        className="modal custom-modal fade"
        id="updateProductModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="imageZoomModalTitle">
                Update Products
              </h5>
              <button
                type="button"
                className="custon-close-button-color close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="col-12 grid-margin">
                <div className="card">
                  <div className="card-body">
                    {/* <h4 className="card-title">Update product Details</h4> */}
                    <form className="form-sample" onSubmit={updateProduct}>
                      {/* <p className="card-description">Personal info</p> */}
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="Product">Product Name</label>
                            <input
                              type="text"
                              className="form-control"
                              name="product_name"
                              id="Product"
                              placeholder="Product Name"
                              value={selectedRowsData?.product_name}
                              onChange={updateHandleChange}
                              required
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="Size">Size</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Size"
                              name="size"
                              id="Size"
                              value={selectedRowsData?.size}
                              onChange={updateHandleChange}
                              required
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="name">Company Name</label>
                            <input
                              type="text"
                              className="form-control"
                              name="company_name"
                              placeholder="Company Name"
                              id="name"
                              readOnly
                              value={`${companyName}, ${companyLocation}`}
                              required
                            />
                          </div>
                        </div>
                        {/* <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="date">Date</label>
                            <input
                              type="date"
                              className="form-control"
                              name="date"
                              id="date"
                              value={selectedRowsData.date}
                              onChange={updateHandleChange}
                            />
                          </div>
                        </div> */}
                      </div>
                      <button
                        className="btn btn-primary mr-2 mt-3"
                        type="submit"
                        // onClick={updateProduct}
                      >
                        Save
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UpdateProductModal;
